import { useMutation } from '@tanstack/react-query'
import mixpanel from 'mixpanel-browser'
import { loadInclusionDataOverTime } from 'sagas/network'
import { stringifyQueryParams } from 'utils'

import { InclusionDataProps } from 'hooks/useInclusionScoresOverTime'
import { Mutations } from 'api/mutations.enum'
import TAXONOMIES from 'utils/taxonomies'

export const useExportInclusionDataOverTime = (params: InclusionDataProps) => {
    const mutation = useMutation<string, Error, void>({
        mutationKey: [Mutations.exportInclusionDataOverTime, params],
        mutationFn: () => {
            return loadInclusionDataOverTime(stringifyQueryParams(params), 'file')
        },
        onSuccess: () => {
            mixpanel.track(TAXONOMIES.ANALYZE_INCLUSION_DATA_OVER_TIME_EXPORT)
        },
    })

    return mutation
}
